import React, { Component } from "react";
import "../Component.css";
import Plot from "./../../../../utils/customPlotly";
import InfoMessage from "../../../../components/Message/InfoMessage/InfoMessage";
import { generateLegendTitle } from "../../../../utils/chartUtils";
import {
  plotlyLineTypes,
  kpiBasedType,
  kpisMapping,
  chartMarkerSymbolsVariation,
  chartMarkerSymbols,
  chartLineColor,
  plotlyMarkerTypes,
  KPISbyMonth,
  chartStep,
  chartPrivacy,
  benchmarkLineTypes,
  dtickFormat,
  chart_legend_position,
  chartParams,
  legendPosition,
  getAvgTenureFormatted,
} from "../../../../utils/constants";
import { deepClone } from "../../../../utils/copyObject";
import moment from "moment";
import { connect } from "react-redux";
import { Input } from "reactstrap";

import NoKPIDataInDateRange from "../../../../assets/no-kpidata-range.png";
import sortBy from "lodash/sortBy";
import privacyIcon from "../../../../assets/privacy_icon.svg";
import lockIcon from "../../../../assets/lock.svg";
import privacyOfficesBelowIcon from "../../../../assets/privacy-icon-offices-below.svg";
import find from "lodash/find";
import ReactTooltip from "react-tooltip";
import Select from "react-select";

class ChartPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      yAxisFormat:
        this.props.yAxisFormat == null
          ? this.props.yAxisFormat
          : this.props.chartDetails.yAxisFormat
          ? this.props.chartDetails.yAxisFormat
          : "Percentage",
      emptyState: this.props.previewOrContinue,
      kpiType: this.props.kpiType,
      // name: this.props.name!=null&&Object.keys(this.props.name).length>0? this.props.name.value : this.props.chartDetails.name
    };
  }

  navigateToUploadData = () => {
    if (this.props.user.orgAdmin) {
      this.props.history.push("/home/upload-data");
    } else {
      this.props.history.push("/home/upload-data/manual");
    }
  };

  randomColorGenerator = () => {
    let value = Math.floor(Math.random() * 16777215).toString(16);
    let color = `#${value}`.toUpperCase();
    return color;
  };

  chartLineMarkerGenerator = (color, type) => {
    // let value = Math.floor(Math.random()*16777215).toString(16)
    // let color = `#${value}`.toUpperCase();
    let obj;

    if (type === "line") {
      obj = {
        color,
        width: 1,
      };
    } else {
      let marker = Math.floor(Math.random() * 9);
      let variation = Math.floor(Math.random() * 3);
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`;
      obj = {
        color,
        size: 10,
        symbol,
      };
    }
    return obj;
  };

  formatDate = (date) => {
    if (!isNaN(new Date(date))) {
      return moment.utc(date).format("dddd, MMMM Do YYYY");
    }
    return date;
  };

  changeYAxisFormat = (option) => {
    if (
      option &&
      option.value &&
      option.value != undefined &&
      option.value != null
    ) {
      let { value } = option;
      if (value == "Absolute") {
        // {label:'Absolute',value:'Absolute'} }
        this.setState({ yAxisFormat: "Absolute" });
      } else {
        // {label:'Percentage',value:'Percentage'}
        this.setState({ yAxisFormat: "Percentage" });
      }
      this.props.yAxisFormat(value);
    }
  };

  toggle = () => {
    const { dropdownOpen } = this.state;
    this.setState({ dropdownOpen: !dropdownOpen });
  };

  render() {
    let {
      previewOrContinue,
      privacy,
      startDate,
      endDate,
      kpiData,
      benchmarkData,
      useLatestDataAvailable,
      step,
      selectedKpiRecords,
      industriesList,
      user,
      benchmarkLocation,
    } = deepClone(this.props);

    let emptyStateImage = previewOrContinue,
      alert = null,
      yRange,
      isEmpKpi,
      yTickFormat,
      templateText,
      tickFormatting = "%B %e, %Y",
      fixedY,
      noKpiDateInDateRangeView = null,
      onlyKpiPointAvailableMsg = null,
      benchmarkDateExpandedMsg = null,
      chartPreview,
      dateRangeDataAvailable = true,
      plotlyData = [],
      min = 0,
      max = 1;

    let { name, yAxisFormat } = this.state;

    let dtickFormatVal, xMinDate, xMaxDate;

    if (this.props.kpiRecords && this.props.kpiRecords.length > 0) {
      if (this.props.kpiRecords[0].kpiType != "") {
        if (this.props.kpiRecords[0].kpiType == kpiBasedType.empDataBased) {
          isEmpKpi = true;
        } else {
          isEmpKpi = false;
        }
      } else {
        isEmpKpi =
          this.state.kpiType == kpiBasedType.empDataBased ? true : false;
      }
    } else if (
      this.props.selectedKpiRecords &&
      this.props.selectedKpiRecords.length > 0
    ) {
      if (
        this.props.selectedKpiRecords[0].kpiType == kpiBasedType.empDataBased
      ) {
        isEmpKpi = true;
      } else if (this.props.kpiType && this.props.kpiType != "") {
        isEmpKpi =
          this.props.kpiType == kpiBasedType.empDataBased ? true : false;
      } else {
        isEmpKpi =
          this.props.kpiType == kpiBasedType.empDataBased ? true : false;
      }
    } else if (this.props.kpiType && this.props.kpiType != "") {
      isEmpKpi = this.props.kpiType == kpiBasedType.empDataBased ? true : false;
    }

    if (kpiData && kpiData.length > 0) {
      kpiData = kpiData.filter((e) => {
        if (e.score && e.score.length > 0) {
          return e;
        }
      });

      // console.log('kpiData: ', kpiData)
      isEmpKpi = this.props.kpiType == kpiBasedType.empDataBased ? true : false;
      const previewKpiData = kpiData.map((kpi, i) => {
        let kpiCount = i + 1;
        kpi.dateRangeDataAvailable = true;
        const sortedKpiAggregate = sortBy(kpi.score, (kpi) => kpi.date);
        const singleKpi = sortedKpiAggregate.length === 1;
        let totalEmployeesArray = sortedKpiAggregate.filter(
          (kpi) => kpi.totalEmployees
        );
        // let name = kpi.kpiId.description ? generateLegendTitle(kpi,kpi.kpiId.description, i, false, "",""): '';
        let name = kpi.kpiId.description
          ? generateLegendTitle(kpi, kpi.kpiId.description, i, false, "", "")
          : `KPI ${i + 1} `;

        let y;
        let description = kpi.kpiId.description
          ? generateLegendTitle(kpi, kpi.kpiId.description, i, false, "", "")
          : `KPI ${i + 1} `;

        let avgTenure = false;

        let text = sortedKpiAggregate.map((k) => {
          // if(kpi.kpiBasedType)
          console.log("sorted Txt kpi ---- ", k);
          let kpi = k.data || {};
          if (k && k.avgTenure) {
            avgTenure = true;
          }
          // avgTenure = k && k.avgTenure? k.avgTenure: false
          let numType =
            k.numeratorType !== undefined ? k.numeratorType : kpi.numeratorType;
          let numeratorCount =
            k.numeratorCount !== undefined
              ? k.numeratorCount
              : kpi.numeratorCount;
          let total =
            k.totalEmployees !== undefined
              ? k.totalEmployees
              : kpi.totalEmployees
              ? kpi.totalEmployees
              : 0;
          let kpiCode = k.kpiCode !== undefined ? k.kpiCode : kpiCode1;
          let ethnicity = k && k.ethnicity ? k.ethnicity : "";
          // console.log(numType)
          let numeratorType =
            numType && numType.indexOf("-") > -1
              ? numType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()
              : numType
              ? numType.toLowerCase()
              : "";
          let result,
            textString = [];

          if (KPISbyMonth.indexOf(kpiCode) > -1) {
            // console.log('kpiMonth---',k)
            let t = moment.utc(k.date).format("MMMM YYYY");
            textString.push(t);
          } else {
            // console.log('kpiMonth---',kpi)
            let t = moment.utc(k.date).format("MMMM D, YYYY");
            textString.push(t);
          }

          // console.log(numeratorCount, numeratorType)
          if (
            !numeratorCount ||
            numeratorCount === undefined ||
            typeof numeratorCount == "undefined"
          ) {
            numeratorCount = 0;
          }

          let value_floor = Math.round(k.value);

          if (
            numeratorType &&
            numeratorCount >= 0 &&
            total > 0 &&
            total != undefined
          ) {
            if (kpiCode === "COMP-2" || kpiCode === "COMP-1") {
              isEmpKpi = false;
              result = `${ethnicity} ${numeratorType} count: ${numeratorCount}${
                yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
              }, male count: ${total ? total - numeratorCount : undefined}`;
            } else {
              isEmpKpi = true;
              result = `${ethnicity} ${numeratorType} count: ${numeratorCount}${
                yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
              }, total: ${total ? total : undefined}`;
            }
          } else if (
            numeratorType &&
            numeratorCount >= 0 &&
            (!total || total === 0)
          ) {
            isEmpKpi = false;
            result = `${ethnicity} ${numeratorType} count: ${numeratorCount}${
              yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
            }`;
          } else if (total >= 0 && numeratorCount === 0 && !numeratorType) {
            result = total && total !== undefined ? `of total: ${total}` : "";
          } else {
            result = "";
          }
          textString.push(result);

          if (k.avgTenure && k.avgTenure != null) {
            textString.push(getAvgTenureFormatted(k.avgTenure));
          } else {
            textString.push("N/A");
          }

          // console.log(avgTenure,'-------- textString final ----> ', textString)
          return textString;
        });

        if (yAxisFormat === "Absolute") {
          y = sortedKpiAggregate.map((kpi) =>
            kpi.data.numeratorCount !== undefined
              ? kpi.data.numeratorCount
              : kpi.numeratorCount
          );
          if (avgTenure) {
            templateText =
              "<b>%{text[0]}</b> <br> " +
              `<b>%{y:.0}</b> (KPI ${kpiCount}) <br>` +
              "%{text[1]}<br>" +
              " Avg Tenure: %{text[2]} <br>" +
              "<extra></extra>";
          } else {
            templateText =
              "<b>%{text[0]}</b> <br> " +
              `<b>%{y:.0}</b> (KPI ${kpiCount}) <br>` +
              "%{text[1]}<br>" +
              "<extra></extra>";
          }
        } else {
          y = sortedKpiAggregate.map((kpi) => Math.round(kpi.value) / 100);
          if (avgTenure) {
            templateText =
              "<b>%{text[0]}</b>  <br>" +
              `<b>%{y:.0%}</b> (KPI ${kpiCount}) <br>` +
              "%{text[1]}<br>" +
              " Avg tenure: %{text[2]}<br>" +
              "<extra></extra>";
          } else {
            templateText =
              "<b>%{text[0]}</b>  <br>" +
              `<b>%{y:.0%}</b> (KPI ${kpiCount}) <br>` +
              "%{text[1]}<br>" +
              "<extra></extra>";
          }
        }

        sortedKpiAggregate.map((kpi) => {
          let yVal;
          if (yAxisFormat === "Absolute") {
            yVal =
              kpi.data.totalEmployees !== undefined
                ? kpi.data.totalEmployees
                : kpi.totalEmployees;
          } else {
            yVal = kpi.value / 100;
          }
          // console.log('yval---',yVal)
          if (yVal > max) {
            max = yVal;
          }
        });

        if (yAxisFormat == "Absolute") {
          yRange = [-0.05, max + 25];
          yTickFormat = undefined;
        } else {
          yRange = [-0.05, max + 0.1];
          yTickFormat = "%";
        }

        let kpiCode1 = kpi.kpiId && kpi.kpiId.code ? kpi.kpiId.code : "";

        console.log("avgTenure ----- ", avgTenure);
        console.log("templateText ----- ", templateText);
        // if (yAxisFormat === "Absolute") {
        //   y = sortedKpiAggregate.map((kpi) =>
        //     kpi.data.numeratorCount !== undefined
        //       ? kpi.data.numeratorCount
        //       : kpi.numeratorCount
        //   );
        //   templateText =
        //     "<b>%{text[0]}</b> <br> " +
        //     `<b>%{y:.0}</b> (KPI ${kpiCount}) <br>` +
        //     "%{text[1]}<br>" +
        //     avgTenure? "Average tenure of {text[2]} years<br>" :'' +
        //     "<extra></extra>";
        // } else {
        //   y = sortedKpiAggregate.map((kpi) => Math.round(kpi.value) / 100);
        //   templateText =
        //     "<b>%{text[0]}</b>  <br>" +
        //     `<b>%{y:.0%}</b> (KPI ${kpiCount}) <br>` +
        //     "%{text[1]}<br>" +
        //     avgTenure? "Average tenure of {text[2]} years<br>" :'' +
        //     "<extra></extra>";
        // }

        let chartColor = chartLineColor(i);
        // let text = sortedKpiAggregate.map(kpi => `${(kpi.data.numeratorType).toLowerCase()} count: ${kpi.data.numeratorCount}, total: ${totalEmployeesArray.length>0 ? kpi.totalEmployees :null}`);
        let x = sortedKpiAggregate.map((kpi, idx) => {
          let { date } = kpi;
          let date1 = moment.utc(date).format("YYYY-MM");
          if (xMinDate == undefined || xMinDate > date1) {
            xMinDate = date1;
          }

          if (xMaxDate == undefined || date1 > xMaxDate) {
            xMaxDate = date1;
          }
          return date;
        });

        console.log("x previw", x);

        dtickFormatVal = dtickFormat(xMinDate, xMaxDate);

        // kpiCount
        let type = "scatter";
        let hovertemplate = templateText;
        // let  line = plotlyLineTypes[i];
        // let  marker =  singleKpi && kpiData.length <2 ? plotlyMarkerTypes[i] : plotlyMarkerTypes[i];
        let line = this.chartLineMarkerGenerator(chartColor, "line");
        let marker = this.chartLineMarkerGenerator(chartColor, "marker");
        let xaxis = "x";
        let yaxis = "y";
        let lines = "scatter";
        let mode = "lines+markers";
        if (totalEmployeesArray.length > 0 || text.length > 0) {
          return {
            name,
            description,
            y,
            x,
            text,
            type,
            line,
            marker,
            xaxis,
            yaxis,
            lines,
            mode,
            hovertemplate,
          };
        } else {
          return {
            name,
            description,
            y,
            x,
            type,
            line,
            marker,
            xaxis,
            yaxis,
            lines,
            mode,
            hovertemplate,
          };
        }
      });
      plotlyData = plotlyData.concat(previewKpiData);
    }
    // console.log('preview---', plotlyData)
    if (
      benchmarkData &&
      benchmarkData != null &&
      benchmarkData.score &&
      benchmarkData.score.length > 0 &&
      kpiData.length === 1
    ) {
      let benchmark = {};
      if (benchmarkData) {
        let { score } = benchmarkData;
        let sortedDataArray = sortBy(score, (data) => data.date);
        const singleBenchmark = sortedDataArray.length === 1;
        let industry = find(industriesList, {
          _id: user.organizationId.industry,
        });
        benchmark.name = generateLegendTitle(
          kpiData[0],
          kpiData[0].kpiId.description,
          0,
          true,
          industry ? industry.name : "",
          benchmarkData.location
            ? benchmarkData.location
            : benchmarkLocation && benchmarkLocation !== null
            ? benchmarkLocation.state
            : ""
        );
        benchmark.description = generateLegendTitle(
          kpiData[0],
          kpiData[0].kpiId.description,
          0,
          true,
          industry ? industry.name : "",
          benchmarkData.location
            ? benchmarkData.location
            : benchmarkLocation && benchmarkLocation !== null
            ? benchmarkLocation.state
            : ""
        );

        benchmark.x = sortedDataArray.map((benchmark) => benchmark.date);
        benchmark.y = sortedDataArray.map((benchmark) => benchmark.value / 100);
        benchmark.type = "scatter";
        benchmark.line = benchmarkLineTypes[0];
        benchmark.marker = singleBenchmark
          ? plotlyMarkerTypes[3]
          : plotlyMarkerTypes[0];
        benchmark.xaxis = "x";
        benchmark.yaxis = "y";
      }
      plotlyData = plotlyData.concat(benchmark);
    }

    let plotlyKpiData = plotlyData.filter(
      (data) =>
        data.name !== "Benchmark for KPI" &&
        data.x.length > 0 &&
        data.y.length > 0
    );
    let plotlyBenchMarkData = plotlyData.filter(
      (data) => data.name === "Benchmark for KPI"
    );
    let combinedPlotlyData = [...plotlyKpiData, ...plotlyBenchMarkData];
    if (
      kpiData.length > 0 &&
      plotlyKpiData.length === 0 &&
      startDate != null &&
      (endDate != null || useLatestDataAvailable) &&
      step === chartStep.details
    ) {
      dateRangeDataAvailable = false;
    } else if (plotlyKpiData.length === 1 && step === chartStep.details) {
      if (plotlyKpiData[0].y.length === 1) {
        onlyKpiPointAvailableMsg = (
          <div className="mt20 mb20">
            <InfoMessage
              msg="There’s only 1 data point available in the date range you selected."
              subMsg="To see more data, please change your selected dates or upload more data."
            />
          </div>
        );
      }
      //   else if (selectedKpiRecords && selectedKpiRecords.length>1) {
      //   onlyKpiPointAvailableMsg = <div className="mt20 mb20">
      //       <InfoMessage msg="You selected more than 1 KPI - no benchmark data will be available." subMsg="If you want to see the benchmark data, please go back and select only one KPI from the list." />
      //     </div>;
      //  }
    }

    if (!dateRangeDataAvailable || this.state.emptyState) {
      noKpiDateInDateRangeView = (
        <div className="text-center no-data-available-desc">
          <p style={{ marginBottom: "0px" }}>
            Looks like there's no data available for the parameters you
            selected.
          </p>
          <p>
            {" "}
            Try adjusting your KPI selection, filters, dates or ask your Admin
            to upload the necessary data.
            {/* Try adjusting your KPI selection, filters, dates or <a className="cursor-pointer" style={{color: '#007bff'}} onClick={this.navigateToUploadData}>upload data</a> */}
          </p>
          <img src={NoKPIDataInDateRange} className="no-kpi-date-range" />
        </div>
      );
    }

    let tickvalsString = null;
    if (combinedPlotlyData.length === 1) {
      if (combinedPlotlyData[0].x.length === 1) {
        // console.log(combinedPlotlyData[0])

        tickvalsString = [combinedPlotlyData[0].x[0]];
      }
    }

    if (combinedPlotlyData.length > 1) {
      let tickvalsDates = 0;
      let tickvalsList = combinedPlotlyData.map((data) => {
        // console.log(data.y)
        if (data.y > 100) {
          fixedY = false;
        }
        let xvalues = data.x;
        return xvalues;
      });
      // console.log(tickvalsList)
      let filteredTickvalsList = tickvalsList.filter(
        (tickValue) => tickValue.length === 1
      );
      if (
        tickvalsString == null &&
        tickvalsList.length > 0 &&
        tickvalsList.length === filteredTickvalsList.length
      ) {
        let firstTickVal = filteredTickvalsList[0][0];
        let filterTickVal = filteredTickvalsList.filter((tickVal) =>
          moment(tickVal[0]).isSame(firstTickVal, "month")
        );
        // console.log(filterTickVal)
        if (filterTickVal.length === filteredTickvalsList.length) {
          tickvalsString = [firstTickVal];
        }
      }
    }

    console.log("dtickFormatVal", dtickFormatVal);
    // console.log('tick---',tickvalsString)

    if (combinedPlotlyData.length > 0) {
      chartPreview = (
        <div>
          <Plot
            data={combinedPlotlyData}
            layout={{
              showlegend: true,
              autosize: true,
              pull: [0.8, 0, 0],
              uirevision: true,
              legend: chartParams({ kpiData, combinedPlotlyData }, "legend"),
              paper_bgcolor: "white",
              plot_bgcolor: "#e5ecf694",
              margin: chartParams({}, "margin"),
              xaxis: chartParams(
                {
                  plotlyDTick: dtickFormatVal,
                  tickvalsString,
                  xMinDate,
                  xMaxDate,
                },
                "xaxis"
              ),
              yaxis: chartParams({ yTickFormat, yRange }, "yaxis"),
              hovermode: "closest",
            }}
            // useResizeHandler={true}
            scrollZoom={true}
            // config={{displayModeBar:false}}
            config={chartParams({}, "config")}
            className="kpiCharts"
            // style={{width:'100%'}}
          />
          {/* {combinedPlotlyData && combinedPlotlyData.length>0?
              combinedPlotlyData.map((e,idx)=>{
                return(
                  <div className="legendContainer" key={e.name}>
                  <div className="legendsDiv">
                    <div className="legendsTitle">
                      {e.description}
                    </div>
                  </div>
                </div>
                )
                
              })
             
              :
            null
            } */}
        </div>
      );
    } else if (emptyStateImage && combinedPlotlyData.length === 0) {
      noKpiDateInDateRangeView = (
        <div className="text-center no-data-available-desc">
          <p style={{ marginBottom: "0px" }}>
            Looks like there's no data available for the parameters you
            selected.
          </p>
          <p>
            {" "}
            Try adjusting your KPI selection, filters, dates or ask your Admin
            to upload the necessary data.
          </p>
          <img src={NoKPIDataInDateRange} className="no-kpi-date-range" />
        </div>
      );
    }
    let chartEndDate = useLatestDataAvailable ? "Current" : this.props.endDate;

    return (
      <div>
        {onlyKpiPointAvailableMsg}
        {benchmarkDateExpandedMsg}
        <div
          className="chart-preview-container"
          style={{
            minHeight: this.props.step === "Privacy" ? "330px" : "inherit",
          }}
        >
          <div className="chart-preview-inner-container">
            {isEmpKpi ? (
              <Select
                name="kpi-select"
                placeholder={"Select KPI..."}
                value={
                  yAxisFormat != "Absolute"
                    ? { value: "Percentage", label: "Percentage" }
                    : { value: "Absolute", label: "Absolute" }
                }
                className="yAxisFormatSelect"
                isOpen={true}
                onChange={(option) => this.changeYAxisFormat(option)}
                options={[
                  { value: "Percentage", label: "Percentage" },
                  { value: "Absolute", label: "Absolute" },
                ]}
                isClearable={false}
                // disabled={this.props.isOwner}
              />
            ) : null}

            {!this.props.step === "Privacy" ? (
              <div
                className="text-center mb10 chart-preview-heading"
                style={{ lineHeight: "33px" }}
              >
                Chart Preview{" "}
              </div>
            ) : null}
            {this.props.chartDetails.selectedOffice &&
            this.props.chartDetails.selectedOffice.label ? (
              <div
                className="chartOfficeName"
                style={{
                  fontSize: this.props.step === "Privacy" ? "20px" : "inherit",
                }}
              >
                <span>
                  Office - {this.props.chartDetails.selectedOffice.label}
                </span>

                {this.props.step === "Privacy" ? (
                  <div className="chart-preview-date">
                    {this.formatDate(this.props.startDate)} -{" "}
                    {this.formatDate(chartEndDate)}
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="chartOfficeName">
                <span className="chartPreviewTitleInitial">
                  {" "}
                  Please Select KPIs Above{" "}
                </span>
              </div>
            )}
            {!this.props.step === "Privacy" ? (
              <div className={name !== "" || privacy !== "" ? "mt20 mb20" : ""}>
                <span className="chart-preview-title" data-tip={name}>
                  {name}
                </span>

                <ReactTooltip />
                {(!step || step === chartStep.privacy) &&
                  (privacy &&
                  privacy != "" &&
                  privacy === chartPrivacy.private ? (
                    <img
                      style={{
                        height: "25px",
                        marginLeft: "12px",
                        marginBottom: "15px",
                      }}
                      src={lockIcon}
                    />
                  ) : privacy === chartPrivacy.office ? (
                    <img
                      style={{
                        height: "20px",
                        marginBottom: "17px",
                        marginLeft: "12px",
                        marginBottom: "15px",
                      }}
                      src={privacyIcon}
                    />
                  ) : (
                    <img
                      style={{
                        height: "20px",
                        marginBottom: "17px",
                        marginLeft: "12px",
                        marginBottom: "15px",
                      }}
                      src={privacyOfficesBelowIcon}
                    />
                  ))}
              </div>
            ) : null}

            <div
              className="chartPreviewContainer"
              style={{
                backgroundColor:
                  noKpiDateInDateRangeView === null ? "#F3F3F4" : "white",
              }}
            >
              {chartPreview}

              {(combinedPlotlyData.length === 0 ||
                this.state.emptyStateImage) &&
                noKpiDateInDateRangeView}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    chartDetails: state.analytics.chartDetails,
    categoryKpiData: state.analytics.categoryKpiData,
    benchmarkOptions: state.analytics.benchmarkOptions,
    user: state.user.profile,
  };
};

export default connect(mapStateToProps)(ChartPreview);
